export const SOLUTIA = [
    "#208774",
    "#ffa600",
    "#2e926a",
    "#d4ab00",
    "#479b5c",
    "#65a349",
    "#87a832",
    "#acab18",
]